var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plan"},[_c('plan-title'),_c('plan-control',{attrs:{"planId":_vm.id,"isFull":false}}),_c('course'),_c('plan-price'),_c('plan-control',{attrs:{"planId":_vm.id,"isFull":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }